export interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  originalPrice?: number;
  unit: string;
  rating: number;
  reviews: number;
  image: string;
  seller: {
    id: string;
    name: string;
    location: string;
    rating: number;
    verified: boolean;
    joinedDate: string;
    responseRate: string;
  };
  stock: number;
  description: string;
  features: string[];
  tags: string[];
  isNew?: boolean;
  isBestSeller?: boolean;
  discountPercentage?: number;
}

export const categories = [
  { id: 'seeds', name: 'Seeds & Seedlings', icon: '🌱', count: 120 },
  { id: 'fertilizers', name: 'Fertilizers & Chemicals', icon: '🧪', count: 85 },
  { id: 'equipment', name: 'Farm Equipment', icon: '🚜', count: 45 },
  { id: 'produce', name: 'Fresh Produce', icon: '🥕', count: 200 },
  { id: 'livestock', name: 'Livestock & Poultry', icon: '🐄', count: 60 },
  { id: 'feed', name: 'Animal Feed', icon: '🌾', count: 90 },
  { id: 'services', name: 'Farm Services', icon: '🛠️', count: 30 },
];

export const mockProducts: Product[] = [
  {
    id: '123e4567-e89b-12d3-a456-426614174001',
    name: 'Premium Hybrid Maize Seeds (H614)',
    category: 'Seeds & Seedlings',
    price: 2400,
    originalPrice: 2800,
    unit: '2kg packet',
    rating: 4.8,
    reviews: 124,
    image: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's1',
      name: 'Kenya Seed Company',
      location: 'Kitale',
      rating: 4.9,
      verified: true,
      joinedDate: '2020-01-15',
      responseRate: '98%',
    },
    stock: 500,
    description: 'High-yielding hybrid maize variety suitable for high altitude areas. Resistant to rust and blight. Matures in 5-6 months.',
    features: ['High Yield', 'Drought Resistant', 'Disease Resistant'],
    tags: ['maize', 'seeds', 'hybrid'],
    isBestSeller: true,
    discountPercentage: 14,
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174002',
    name: 'Organic NPK Fertilizer',
    category: 'Fertilizers & Chemicals',
    price: 3500,
    unit: '50kg bag',
    rating: 4.5,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1628519592419-780829c5a319?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's2',
      name: 'Green Earth Organics',
      location: 'Nairobi',
      rating: 4.7,
      verified: true,
      joinedDate: '2021-03-10',
      responseRate: '95%',
    },
    stock: 200,
    description: 'Balanced organic fertilizer enriched with micronutrients. Improves soil structure and water retention.',
    features: ['Organic', 'Slow Release', 'Eco-friendly'],
    tags: ['fertilizer', 'organic', 'soil'],
    isNew: true,
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174003',
    name: 'Drip Irrigation Kit (1 Acre)',
    category: 'Farm Equipment',
    price: 15000,
    originalPrice: 18000,
    unit: 'kit',
    rating: 4.9,
    reviews: 45,
    image: 'https://images.unsplash.com/photo-1563514227147-6d2ff665a6a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's3',
      name: 'AgriTech Solutions',
      location: 'Thika',
      rating: 4.8,
      verified: true,
      joinedDate: '2019-11-20',
      responseRate: '99%',
    },
    stock: 15,
    description: 'Complete drip irrigation system for 1 acre. Includes tank connectors, main pipes, drip lines, and fittings. Easy to install.',
    features: ['Water Saving', 'Easy Installation', 'Durable'],
    tags: ['irrigation', 'water', 'equipment'],
    discountPercentage: 17,
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174004',
    name: 'Fresh Red Tomatoes (Crate)',
    category: 'Fresh Produce',
    price: 4500,
    unit: '60kg crate',
    rating: 4.6,
    reviews: 56,
    image: 'https://images.unsplash.com/photo-1592924357228-91a4daadcfea?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's4',
      name: 'Mama Mboga Wholesale',
      location: 'Mombasa',
      rating: 4.5,
      verified: false,
      joinedDate: '2022-06-05',
      responseRate: '90%',
    },
    stock: 50,
    description: 'Freshly harvested ripe tomatoes. Perfect for market resale or large scale cooking. Grown in open field.',
    features: ['Fresh', 'Organic', 'Farm Direct'],
    tags: ['tomatoes', 'vegetables', 'fresh'],
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174005',
    name: 'Walking Tractor (12HP)',
    category: 'Farm Equipment',
    price: 180000,
    unit: 'unit',
    rating: 4.7,
    reviews: 12,
    image: 'https://images.unsplash.com/photo-1591086594892-986e1af3d8f7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's5',
      name: 'Farm Machineries Ltd',
      location: 'Nakuru',
      rating: 4.6,
      verified: true,
      joinedDate: '2018-05-15',
      responseRate: '92%',
    },
    stock: 5,
    description: 'Versatile 2-wheel walking tractor. Comes with plough and rotavator attachments. Diesel engine.',
    features: ['Diesel Engine', 'Multi-purpose', 'Heavy Duty'],
    tags: ['tractor', 'machinery', 'equipment'],
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174006',
    name: 'Kienyeji Chicken (Improved)',
    category: 'Livestock & Poultry',
    price: 800,
    unit: 'bird',
    rating: 4.4,
    reviews: 34,
    image: 'https://images.unsplash.com/photo-1548550023-2bdb3c5c6d98?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's6',
      name: 'Poultry Palace',
      location: 'Kiambu',
      rating: 4.7,
      verified: true,
      joinedDate: '2021-08-12',
      responseRate: '96%',
    },
    stock: 200,
    description: '4-month old improved Kienyeji chickens. Vaccinated and healthy. Good for meat or eggs.',
    features: ['Vaccinated', 'Free Range', 'Healthy'],
    tags: ['chicken', 'poultry', 'livestock'],
    isBestSeller: true,
  },
];
